/* LALTERNATIVA - pagina prodotto.
   Prima stava scritto a mano dentro layout/theme.liquid: spostato qui per
   poterlo leggere e correggere senza rimettere mano al layout.
   Fa tre cose: filtro colore sulla galleria, iniezione della descrizione,
   spostamento di "Guida alle taglie" accanto alla taglia.

   PERCHE IL FILTRO COLORE GIRA SOLO DA 768px IN SU
   La galleria cambia natura con la larghezza:
     - da 768px in su e una griglia a 2 colonne (classe md:flickity-disable)
     - sotto i 768px e un carosello Flickity
   Il filtro nasconde le foto degli altri colori con display:none. In una
   griglia funziona; in un carosello no, perche Flickity calcola le posizioni
   una volta sola e continua a contare anche le celle nascoste. Su un capo con
   8 colori diventavano 58 celle di cui 51 invisibili ma ancora contate: il
   contatore diceva "9 / 58" e scorrendo si finiva su spazi vuoti.
   Si potrebbe filtrare anche su mobile togliendo le celle dal DOM e
   re-inizializzando il carosello: provato, funziona al primo giro ma al
   secondo cambio colore la galleria resta bianca. Meglio un carosello che
   funziona con tutte le foto che uno filtrato che si rompe. */
(function () {
  function isGrid() {
    return window.matchMedia('(min-width: 768px)').matches;
  }

  /* ---------- 1. filtro colore (solo griglia desktop) ---------- */
  var colorMap = null;
  var lastColor = null;

  function buildColorMap() {
    try {
      var groups = document.getElementById('LasColorGroups');
      if (groups) {
        var data = JSON.parse(groups.textContent);
        if (data && typeof data === 'object' && Object.keys(data).length > 0) {
          colorMap = {};
          Object.keys(data).forEach(function (col) {
            colorMap[col] = (data[col] || []).map(function (id) {
              return parseInt(id, 10);
            });
          });
          return;
        }
      }
      var pd = document.getElementById('ProductData');
      if (!pd) return;
      var p = JSON.parse(pd.textContent);
      var ci = p.options.findIndex(function (o) {
        return ['colore', 'color', 'colour'].indexOf(o.toLowerCase()) >= 0;
      });
      if (ci < 0) return;
      var ml = p.media || [];
      if (!ml.length) return;
      var fileIndex = {};
      ml.forEach(function (m, i) {
        var u = (m.src || (m.preview_image && m.preview_image.src) || '').split('?')[0];
        var f = u.split('/').pop().split('.')[0];
        if (f) fileIndex[f] = i;
      });
      var firstOfColor = {};
      p.variants.forEach(function (v) {
        var c = v.options[ci];
        if (!c || firstOfColor.hasOwnProperty(c)) return;
        if (!v.featured_image || !v.featured_image.src) return;
        var f = v.featured_image.src.split('?')[0].split('/').pop().split('.')[0];
        var i = fileIndex[f];
        if (i !== undefined) firstOfColor[c] = i;
      });
      if (!Object.keys(firstOfColor).length) return;
      var sorted = Object.keys(firstOfColor).sort(function (a, b) {
        return firstOfColor[a] - firstOfColor[b];
      });
      colorMap = {};
      sorted.forEach(function (c, i) {
        var start = firstOfColor[c];
        var end = i < sorted.length - 1 ? firstOfColor[sorted[i + 1]] - 1 : ml.length - 1;
        colorMap[c] = [];
        for (var j = start; j <= end; j++) colorMap[c].push(ml[j].id);
      });
    } catch (e) {
      colorMap = null;
    }
  }

  function currentColor() {
    var found = null;
    try {
      document.querySelectorAll('.variant-picker__input input[type=radio]:checked').forEach(function (i) {
        if (colorMap && colorMap.hasOwnProperty(i.value)) found = i.value;
      });
    } catch (e) {}
    return found;
  }

  function showAll() {
    document.querySelectorAll('.f-product__media-list--grid-2-cols .f-product__media').forEach(function (el) {
      el.classList.remove('las-color-hidden');
      el.style.removeProperty('display');
    });
  }

  function apply(col) {
    var ids = (colorMap && colorMap[col]) || [];
    if (!ids.length) return;
    document.querySelectorAll('.f-product__media-list--grid-2-cols .f-product__media').forEach(function (el) {
      var mid = parseInt(el.getAttribute('data-media-id') || '0', 10);
      if (ids.indexOf(mid) >= 0) {
        el.classList.remove('las-color-hidden');
        el.style.removeProperty('display');
      } else {
        el.classList.add('las-color-hidden');
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  function refresh(force) {
    if (!isGrid()) {
      showAll();
      lastColor = null;
      return;
    }
    if (!colorMap) {
      buildColorMap();
      if (!colorMap) return;
    }
    var col = currentColor();
    if (!col) return;
    if (force || col !== lastColor) {
      lastColor = col;
      apply(col);
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('.variant-picker')) {
        setTimeout(function () {
          refresh(true);
        }, 10);
        setTimeout(function () {
          refresh(true);
        }, 200);
      }
    },
    true
  );
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.variant-picker')) refresh(true);
  });
  window.addEventListener('resize', function () {
    refresh(true);
  });
  setTimeout(function () {
    refresh(true);
  }, 600);
  setTimeout(function () {
    refresh(true);
  }, 1600);

  /* ---------- 2. descrizione vera ---------- */
  function fixDesc() {
    try {
      var el = document.getElementById('LasProductDesc');
      if (!el) return;
      var html = JSON.parse(el.textContent);
      if (!html) return;
      var blocks = Array.prototype.slice.call(
        document.querySelectorAll('.f-product-single__block--collapsible_tab')
      );
      var block = blocks.filter(function (b) {
        var btn = b.querySelector('button');
        return btn && btn.textContent.trim().toUpperCase().indexOf('DESCRIZIONE') >= 0;
      })[0];
      if (!block) return;
      var content = block.querySelector('.collapsible__content-inner, .rte, .collapsible__content');
      if (content && content.textContent.trim() === 'product.description') {
        content.innerHTML = html;
      }
    } catch (e) {}
  }
  setTimeout(fixDesc, 800);
  setTimeout(fixDesc, 1600);

  /* ---------- 3. Guida alle taglie accanto alla taglia ---------- */
  function moveSizeGuide() {
    try {
      var label = document.querySelector('.variant-picker__button .form__label');
      if (!label || label.querySelector('.las-size-guide')) return;
      var btn = document.querySelector('[role="button"][aria-label="GUIDA TAGLIE"], [aria-label*="GUIDA"][role="button"]');
      if (!btn) return;
      var block = btn.closest('.f-product-single__block');
      var link = document.createElement('span');
      link.className = 'las-size-guide';
      link.textContent = 'Guida alle taglie';
      link.style.cssText =
        'font-size:11px;font-weight:500;color:#3E2724;text-decoration:underline;opacity:.65;margin-left:auto;cursor:pointer;white-space:nowrap;text-underline-offset:2px';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        btn.click();
      });
      label.style.setProperty('display', 'flex', 'important');
      label.style.setProperty('justify-content', 'space-between', 'important');
      label.style.setProperty('align-items', 'baseline', 'important');
      label.style.setProperty('width', '100%', 'important');
      label.appendChild(link);
      if (block) block.style.display = 'none';
    } catch (e) {}
  }
  setTimeout(moveSizeGuide, 1000);
  setTimeout(moveSizeGuide, 2000);
})();
